<template>
  <div class="Header">
    <template v-if="showAppBar">
      <v-app-bar
        app
        class="header-appbar"
        elevation="0"
        v-bind:color="colorAppBar"
        v-bind:class="{
          'background-black': appBarChange == 0,
          'background-white': appBarChange == 1,
        }"
        v-bind:height="heightAppBar"
        fixed
      >
        <v-row align="center" justify="end">
          <v-col>
            <router-link
              to="/"
              class="not-text-decoration"
              v-bind:class="{
                'color-white': appBarChange == 0,
                'color-black': appBarChange == 1,
              }"
            >
              <span class="titles-app rewrite-font-2">
                SEÑOR TANAKA 田中氏
              </span>
            </router-link>
          </v-col>

          <!-- botón de menú -->
          <v-col
            class="d-md-none"
            cols="auto"
            md="6"
            @click="open_submenu = !open_submenu"
          >
            <v-img
              :src="open_submenu ? menuIconClose : menuIcon"
              :class="{ 'menu-close': open_submenu }"
              class="menu-logo"
            ></v-img>
          </v-col>
          <!-- /botón de menú -->

          <!-- del menú en desk -->
          <template v-if="appBarChange == 0">
            <v-col cols="auto" class="px-0 d-none d-md-block">
              <router-link
                to="/menu"
                class="menu-app-item d-inline-block px-4"
                v-bind:class="{
                  'color-white': appBarChange == 0,
                  'color-black': appBarChange == 1,
                }"
                >{{ $t("btnMenu") }}</router-link
              >
            </v-col>
            <!-- <v-col cols="auto" class="px-0">
              <router-link to="/temporada" class="menu-app-item d-inline-block px-4" v-bind:class="{'color-white': appBarChange == 0, 'color-black': appBarChange == 1,}">Temporada</router-link>
            </v-col> -->
            <v-col cols="auto" class="px-0 d-none d-md-block">
              <span
                @click="$vuetify.goTo('#contacto')"
                class="menu-app-item d-inline-block px-4"
                v-bind:class="{
                  'color-white': appBarChange == 0,
                  'color-black': appBarChange == 1,
                }"
                >{{ $t("btnContact") }}</span
              >

              <!-- <router-link
                to="/contacto"
                class="menu-app-item d-inline-block px-4"
                v-bind:class="{
                  'color-white': appBarChange == 0,
                  'color-black': appBarChange == 1,
                }"
                >{{ $t("btnContact") }}</router-link
              > -->
            </v-col>
          </template>
          <template v-if="appBarChange == 1">
            <v-col cols="auto" class="px-0 d-none d-md-block">
              <router-link
                to="/"
                class="menu-app-item d-inline-block px-4"
                v-bind:class="{
                  'color-white': appBarChange == 0,
                  'color-black': appBarChange == 1,
                }"
                >{{ $t("btnHome") }}</router-link
              >
            </v-col>
          </template>
          <v-col cols="auto" class="px-0 d-none d-md-block">
            <a
              href="https://api.whatsapp.com/send/?phone=528183352060&text&type=phone_number&app_absent=0"
              class="menu-app-item d-inline-block px-4"
              v-bind:class="{
                'color-white': appBarChange == 0,
                'color-black': appBarChange == 1,
              }"
              target="_blank"
              >{{ $t("btnHomeService") }}</a
            >
          </v-col>
          <v-col cols="auto" class="px-0 d-none d-md-block">
            <v-menu
              offset-y
              open-on-hover
              :close-on-content-click="true"
              @mouseenter="reservationsMenuOpen = true"
              @mouseleave="reservationsMenuOpen = false"
            >
              <template v-slot:activator="{ on, attrs }">
                <span
                  class="menu-app-item outlined px-4"
                  v-bind:class="{
                    'color-white': appBarChange == 0,
                    'color-black': appBarChange == 1,
                  }"
                  v-bind="attrs"
                  v-on="on"
                  style=""
                >
                  {{ $t("btnReservations") }}
                  <v-icon
                    :style="{
                      transform: reservationsMenuOpen
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }"
                    v-bind:class="{
                      'color-white': appBarChange == 0,
                      'color-black': appBarChange == 1,
                    }"
                    class="menu-app-item--icon"
                  >
                    mdi-chevron-down
                  </v-icon>
                </span>
              </template>

              <v-list class="menu-app-item--items">
                <v-list-item
                  href="https://www.opentable.com.mx/booking/restref/availability?lang=es-MX&fbclid=IwAR2BZUVqFF2PuPmznPeiaMohgb6lWr7I9YESpWrWvK5qnopoPhfa2qdCoLU&correlationId=10a70b36-7590-423f-8c49-b8ad42272919&restRef=5254&referrerId=10792"
                  target="_blank"
                  class="menu-app-item--items__item"
                >
                  OpenTable
                </v-list-item>
                <v-list-item
                  href="https://www.covermanager.com/reservation/module_restaurant/senor-tanaka-monterrey/spanish"
                  target="_blank"
                  class="menu-app-item--items__item"
                >
                  CoverManager
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <div class="pl-10" v-if="$vuetify.breakpoint.smAndUp">
            <span
              @click="setLocale('en')"
              class="active-lang"
              :class="{ 'opacity-custom': this.$i18n.locale == 'en' }"
              >ENG</span
            >
            <span class="px-4">-</span>
            <span
              @click="setLocale('es')"
              class="active-lang"
              :class="{ 'opacity-custom': this.$i18n.locale == 'es' }"
              >ESP</span
            >
          </div>
          <!-- /del menú en desk -->
        </v-row>
      </v-app-bar>

      <!-- submenú -->
      <subMenu :show="open_submenu" :appBarChange="appBarChange"></subMenu>
      <!-- /submenú -->
    </template>
  </div>
</template>
<script>
import subMenu from "../static/SubMenu";
import menuIcon from "@/assets/icons/menu-mobile.svg";
import menuIconClose from "@/assets/icons/menu-mobile-close.svg";

export default {
  name: "Header",
  components: {
    subMenu,
  },
  props: {
    appBarChange: { type: Number, required: true },
  },
  computed: {
    colorAppBar() {
      var blackColor = "#000000";
      var whiteColor = "#FFFFFF";

      if (this.appBarChange == 0) {
        return blackColor;
      } else if (this.appBarChange == 1) {
        return whiteColor;
      }
    },
  },
  data() {
    return {
      lang: "es",
      itemsNav: [
        {
          text: "menú",
          url: "/menu",
        },
        {
          text: "temporada",
          url: "/temporada",
        },
        {
          text: "contacto",
          url: "/contacto",
        },
        {
          text: "reservaciones",
          url: "https:/www.google.com",
        },
      ],
      open_submenu: false,
      menuIcon,
      menuIconClose,
      heightAppBar: 100,
      showAppBar: false,
      reservationsMenuOpen: false,
    };
  },
  watch: {
    $route(to, from) {
      this.open_submenu = false;
      this.showAppBar = false;
    },
    lang() {},
    showAppBar: function (val) {
      if (!val) {
        setTimeout(() => {
          this.showAppBar = true;
        }, 7000);
      }
    },
  },
  beforeCreate() {
    setTimeout(() => {
      this.showAppBar = true;
    }, 7000);
  },
  mounted() {
    //resize about height carousel
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.onResize, { passive: true });
    }
  },
  methods: {
    onResize() {
      //height del appbar
      if (window.innerWidth <= 959) {
        this.heightAppBar = 60;
      } else if (window.innerWidth >= 960) {
        this.heightAppBar = 100;
      }
    },
    setLocale: function (locale) {
      this.$i18n.locale = locale;
      this.lang = locale;
    },
  },
};
</script>